import { render, staticRenderFns } from "./multiplePatternColorFillSolid.vue?vue&type=template&id=5a8f6729&"
import script from "./multiplePatternColorFillSolid.vue?vue&type=script&lang=ts&"
export * from "./multiplePatternColorFillSolid.vue?vue&type=script&lang=ts&"
import style0 from "./multiplePatternColorFillSolid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports